<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();
const router = useRouter();
const accountId = useMapGetter('getCurrentAccountId');

const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

const goToBilling = () => {
  close();
  router.push({
    name: 'wgpt_billing_settings_index',
    params: { accountId: accountId.value },
  });
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('WGPT_CAR_LISTINGS.EDITOR.CREDITS.TITLE')"
    :description="t('WGPT_CAR_LISTINGS.EDITOR.CREDITS.DESCRIPTION')"
    :confirm-button-label="t('WGPT_CAR_LISTINGS.EDITOR.CREDITS.BUY')"
    @confirm="goToBilling"
  />
</template>
